<div class="phone-number-input-wrapper">
  <input type="text" inputmode="tel" #phonenumberInput (input)="onPhoneNumberChange()" (keypress)="validatePhoneInput($event)" />
</div>

@if (isPhoneNumberInvalid) {
  <div class="labels-error-message">
    {{ "customer.Please_enter_a_valid_mobile_number" | translate }}
  </div>
}
